/**
 * Plaid's detailed categories are SHOUTING_SNAKE_CASE identifiers that reach the member in
 * both the prompt they can read and the row detail, so they get real wording. Anything else
 * that looks like an identifier is at least lowercased; labels the API already prettified
 * pass through untouched.
 */
const PLAID_CATEGORY_NOUNS: Record<string, string> = {
  TRANSFER_OUT_ACCOUNT_TRANSFER: 'transfer to another account',
  TRANSFER_OUT_SAVINGS: 'transfer to savings',
  TRANSFER_IN_ACCOUNT_TRANSFER: 'transfer from another account',
  TRANSFER_IN_SAVINGS: 'transfer from savings',
  LOAN_PAYMENTS_CREDIT_CARD_PAYMENT: 'credit card payment',
}

const nounFor = (raw: string): string => {
  const known = PLAID_CATEGORY_NOUNS[raw]
  if (known) return known
  return /^[A-Z0-9_]+$/.test(raw) ? raw.toLowerCase().replace(/_/g, ' ') : raw
}

/** Sentence form, to follow "categorized as". Only the known nouns take an article. */
export const plaidCategoryPhrase = (raw: string): string =>
  PLAID_CATEGORY_NOUNS[raw] ? `a ${PLAID_CATEGORY_NOUNS[raw]}` : nounFor(raw)

/** Label form, for a detail line's value. */
export const plaidCategoryLabel = (raw: string): string => {
  const noun = nounFor(raw)
  return noun.charAt(0).toUpperCase() + noun.slice(1)
}
